//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ''
    },
    classstyle: {
      type: String,
      default: 'col'
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      required: true
    },
    attach: {
      type: Boolean,
      deafult: false
    }
  },
  data: function data() {
    return {
      menu2: false,
      model: this.value
    };
  },
  watch: {
    model: function model(newValue) {
      //console.log("aqui-------------------",newValue)
      this.$emit('input', newValue.value ? newValue.value : newValue);
      this.$emit('change');
    },
    value: function value(newValue) {
      this.model = newValue.value ? newValue.value : newValue;
    }
  }
};